<script setup lang="ts">
/**
 * Badge pokazujacy zrodlo danych (skad rekord trafil do MoreDeal).
 *
 * Faza 1 integracji:
 * - dms        — Autostacja DMS (MS SQL replica → ETL co 5 min)
 * - excel      — manual upload CSV/XLSX (wizard)
 * - mycarapp   — MyCarApp REST (webhook + polling)
 * - nadin      — Nadin (Inter Cars) polling adapter
 * - erp        — system ERP klienta (SAP/Comarch/Optima — adapter per-tenant)
 * - ocr        — Document scan (Claude Vision) — wprowadzenie z dokumentu
 * - manual     — Quick-entry przez doradce w PWA
 */
export type DataSource = 'dms' | 'excel' | 'mycarapp' | 'nadin' | 'erp' | 'ocr' | 'manual';

const meta: Record<DataSource, { label: string; short: string; color: string; bg: string }> = {
  dms: { label: 'Autostacja DMS', short: 'DMS', color: '#1E40AF', bg: '#1E40AF20' },
  excel: { label: 'Import CSV/XLSX', short: 'XLS', color: '#0F6E3E', bg: '#0F6E3E20' },
  mycarapp: { label: 'MyCarApp', short: 'MCA', color: '#7C3AED', bg: '#7C3AED20' },
  nadin: { label: 'Nadin (Inter Cars)', short: 'NDN', color: '#F59E0B', bg: '#F59E0B20' },
  erp: { label: 'ERP klienta', short: 'ERP', color: '#0EA5E9', bg: '#0EA5E920' },
  ocr: { label: 'Skan dokumentu (OCR)', short: 'OCR', color: '#EC4899', bg: '#EC489920' },
  manual: { label: 'Quick-entry doradcy', short: 'MAN', color: '#6B7280', bg: '#6B728020' },
};

defineProps<{ source: DataSource; size?: 'xs' | 'sm' }>();
</script>

<template>
  <span
    class="inline-flex items-center gap-1 rounded font-bold uppercase tracking-wider whitespace-nowrap"
    :class="size === 'xs' ? 'px-1.5 py-0.5 text-[9px]' : 'px-2 py-0.5 text-[10px]'"
    :style="{
      background: meta[source].bg,
      color: meta[source].color,
      border: `1px solid ${meta[source].color}40`,
    }"
    :title="`Zrodlo: ${meta[source].label}`"
  >
    <span
      class="w-1.5 h-1.5 rounded-full"
      :style="{ background: meta[source].color }"
      aria-hidden="true"
    />
    {{ meta[source].short }}
  </span>
</template>
